export function FooterSection() {
  const legalLinks = [
    {
      title: "Politica de Confidențialitate",
      url: "https://legal.blackfamilyempire.ro/politica-de-confidentialitate.html",
      rel: "nofollow"
    },
    {
      title: "Termeni și Condiții",
      url: "https://legal.blackfamilyempire.ro/termeni-si-conditii.html",
      rel: "nofollow"
    },
    {
      title: "Politica de Cookie",
      url: "https://legal.blackfamilyempire.ro/politica-de-cookies.html",
      rel: "nofollow"
    },
    {
      title: "Termeni de Livrare",
      url: "https://legal.blackfamilyempire.ro/termeni-si-conditii.html#h.48vr9g57jn19",
      rel: "nofollow"
    },
    {
      title: "Politica de Retur",
      url: "https://legal.blackfamilyempire.ro/termeni-si-conditii.html#h.1qged96e1zw9",
      rel: "nofollow"
    }
  ];

  const infoLinks = [
    {
      title: "ANPC",
      url: "https://anpc.ro/",
      rel: "noopener external"
    },
    {
      title: "ANPC - SAL",
      url: "https://anpc.ro/ce-este-sal",
      rel: "noopener external"
    },
    {
      title: "Platforma SOL",
      url: "https://ec.europa.eu/consumers/odr/main/index.cfm",
      rel: "noopener external"
    }
  ];

  const paymentMethods = [
    {
      name: "Visa",
      logo: "https://upload.wikimedia.org/wikipedia/commons/0/04/Visa.svg",
      rel: "noopener payment"
    },
    {
      name: "Mastercard",
      logo: "https://upload.wikimedia.org/wikipedia/commons/a/a4/Mastercard_2019_logo.svg",
      rel: "noopener payment"
    },
    {
      name: "Maestro",
      logo: "https://cdn3.iconfinder.com/data/icons/payment-method-1/64/_Maestro-512.png",
      rel: "noopener payment"
    },
    {
      name: "Apple Pay",
      logo: "https://upload.wikimedia.org/wikipedia/commons/f/fa/Apple_logo_black.svg",
      rel: "noopener payment"
    },
    {
      name: "Google Pay",
      logo: "https://cdn1.iconfinder.com/data/icons/logos-brands-in-colors/436/Google_Pay_GPay_Logo-512.png",
      rel: "noopener payment"
    }
  ];

  return (
    <footer className="bg-black text-gray-400 py-12 sm:py-16 px-4 sm:px-6" itemScope itemType="https://schema.org/Organization">
      <div className="container mx-auto max-w-7xl">
        <div className="grid gap-8 sm:grid-cols-2 lg:grid-cols-4 justify-items-center text-center sm:text-left">
          <div>
            <h4 className="text-white font-bold mb-4 sm:mb-6">Despre Noi</h4>
            <p className="text-sm mb-2" itemProp="legalName">BLACK FAMILY EMPIRE S.R.L.</p>
            <p className="text-sm mb-2" itemProp="taxID">CUI: 47722882</p>
            <p className="text-sm" itemProp="identifier">J40/3962/2023</p>
          </div>
          
          <div>
            <h4 className="text-white font-bold mb-4 sm:mb-6">Contact</h4>
            <a 
              href="tel:0750606606" 
              className="text-sm hover:text-white transition-colors"
              itemProp="telephone"
              rel="nofollow"
            >
              Tel: 0750 606 606
            </a>
          </div>
          
          <div>
            <h4 className="text-white font-bold mb-4 sm:mb-6">Legal</h4>
            <ul className="space-y-2 sm:space-y-3 text-sm">
              {legalLinks.map((link) => (
                <li key={link.title}>
                  <a 
                    href={link.url}
                    className="hover:text-white transition-colors"
                    rel={link.rel}
                    target="_blank"
                  >
                    {link.title}
                  </a>
                </li>
              ))}
            </ul>
          </div>
          
          <div>
            <h4 className="text-white font-bold mb-4 sm:mb-6">Informații</h4>
            <ul className="space-y-2 sm:space-y-3 text-sm">
              {infoLinks.map((link) => (
                <li key={link.title}>
                  <a 
                    href={link.url}
                    className="hover:text-white transition-colors"
                    rel={link.rel}
                    target="_blank"
                  >
                    {link.title}
                  </a>
                </li>
              ))}
            </ul>
            
            <div className="flex flex-wrap justify-center items-center gap-4 mt-6">
              {paymentMethods.map((method) => (
                <img 
                  key={method.name}
                  src={method.logo} 
                  alt={method.name} 
                  className="h-6 sm:h-8"
                  loading="lazy"
                  rel={method.rel}
                />
              ))}
            </div>
          </div>
        </div>

        {/* Additional SEO Links */}
        <div className="mt-8 pt-8 border-t border-gray-800 text-center">
          <p className="text-sm text-gray-500">
            <span itemProp="name">Depresia, Superputerea Ta!</span> - 
            <a 
              href="https://www.tiktok.com/@omulcutourette" 
              className="hover:text-white ml-1"
              rel="author noopener"
              target="_blank"
              itemProp="author"
            >
              Andrei Ungureanu
            </a>
          </p>
          <div className="mt-2 text-xs text-gray-600">
            <a 
              href="https://blackfamilyempire.ro" 
              className="hover:text-gray-400"
              rel="publisher noopener"
              target="_blank"
              itemProp="publisher"
            >
              © 2024 Black Family Empire
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
